<p *ngIf="message && control.invalid && (control.dirty || control.touched)">{{ message }}</p>
